// import React, { useEffect, useRef, useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import "./Navbar.css";

// export default function Navbar({ setBackgroundBlur }) {
//     const [activeNav, setActiveNav] = useState(null);
//     const [isMenuOpen, setIsMenuOpen] = useState(false);
//     const menuRef = useRef(null);
//     const navigate = useNavigate();

//     const handleMouseOver = (index) => {
//         setActiveNav(index);
//         setBackgroundBlur(true); // Apply blur on mouseover
//     };

//     const handleMouseOut = () => {
//         setActiveNav(null);
//         setBackgroundBlur(false); // Remove blur on mouseout
//     };

//     const handleClickOutside = (event) => {
//         if (menuRef.current && !menuRef.current.contains(event.target)) {
//             setIsMenuOpen(false);
//         }
//     };

//     useEffect(() => {
//         document.addEventListener('mousedown', handleClickOutside);
//         return () => {
//             document.removeEventListener('mousedown', handleClickOutside);
//         };
//     }, []);

//     useEffect(() => {
//         // Close the menu when navigating to a new page
//         setIsMenuOpen(false);
//     }, [navigate]);

//     const navItems = [
//         {
//             title: "Our Legacy",
//             link: "/our-legacy",
//             subItems: [
//                 {}
//             ]
//         },
//         {
//             title: "Branches",
//             link: "/branches",
//             subItems: [
//                 {}
//             ]
//         },
//         {
//             title: "Gallery",
//             link: "/gallery",
//             subItems: [
//                 {}
//             ]
//         },
//         {
//             title: "About Us",
//             link: "/about-us",
//             subItems: [
//                 {}
//             ]
//         },
//         {
//             title: "Vision & Mission",
//             link: "/vision-mission",
//             subItems: [
//                 {}
//             ]
//         },
//     ];


//     return (
//         <nav className='bg-black px-4 py-3 md:px-10 max-md:py-1 sm:py-6 max-sm:py-6 xl:py-1 flex justify-center xl:justify-center sm:justify-start max-sm:justify-start items-center fixed w-full z-50'>
//             {/* <div>
//                 <a href='/'>
//                     <img className='w-32 top-4 left-10 xl:left-10 sm:left-5 max-sm:left-5' src='https://ik.imagekit.io/1sb7q2nfg/AL%20BIDAYAH/LOGO/al%20bidaya.png' alt='AL-BIDAYAH' />
//                 </a>
//             </div> */}
//             <div>
//                 <div className='flex justify-between items-center'>
//                     <div className='md:block xl:hidden fixed top-3 right-3'>
//                         <button onClick={() => setIsMenuOpen(!isMenuOpen)} className='text-white focus:outline-none'>
//                             <svg className='w-6 h-6' fill='none' stroke='currentColor' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
//                                 <path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M4 6h16M4 12h16m-7 6h7'></path>
//                             </svg>
//                         </button>
//                     </div>
//                     <ul ref={menuRef} className={`text-white space-x-14 xl:space-x-14 md:space-x-0 md:pt-5 sm:space-x-0 sm:pt-5 max-sm:space-x-0 max-sm:pt-5 lg:pt-5 xl:pt-0 ${isMenuOpen ? 'flex flex-col md:flex-col lg:flex max-md:flex max-lg:flex' : 'hidden sm:hidden md:hidden xl:flex'}`}>
//                         {navItems.map((item, index) => (
//                             <li
//                                 key={index}
//                                 className='heading md:relative'
//                                 onMouseOver={() => handleMouseOver(index)}
//                                 onMouseOut={handleMouseOut}
//                             >
//                                 <Link to={item.link} target={item.target} className='block px-4 py-2 md:px-0'>{item.title}</Link>
//                                 <ul className={`nav-list ${activeNav === index ? 'expanded space-y-2' : 'no_expand'}`}>
//                                     {item.subItems.map((subItem, subIndex) => (
//                                         <li key={subIndex} className='sub-1 max-sm:pl-5'>
//                                             <Link to={subItem.link}>{subItem.name}</Link>
//                                         </li>
//                                     ))}
//                                 </ul>
//                             </li>
//                         ))}
//                     </ul>
//                 </div>
//             </div>
//             <div>
//                 <button onClick={() => navigate('/')} className='bg-sky-500 text-white font-semibold rounded-md absolute right-10 top-2 p-1 px-2 animate-pulse hover:scale-105 transition-transform duration-1000 ease-in-out'>Contact Us</button>
//             </div>
//         </nav>
//     );
// }



// import { motion } from "framer-motion";
// import { Menu } from "lucide-react";

// export default function Navbar({ showLogo }) {
//   return (
//     <div className="fixed top-0 left-0 right-0 z-40 bg-black shadow-md h-20 px-4 flex items-center justify-between">
//       {showLogo && (
//         <motion.img
//           src="https://ik.imagekit.io/1sb7q2nfg/AL%20BIDAYAH/LOGO/al%20bidaya.png"
//           alt="Navbar Logo"
//           className="w-16 h-16"
//           layoutId="site-logo"
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           transition={{ duration: 0.6 }}
//         />
//       )}
//       <Menu className="w-6 h-6 text-white" />
//     </div>
//   );
// }




// import React from "react";
// import { motion } from "framer-motion";

// const Navbar = ({ showSplash, toggleMenu, targetRef }) => {
//   return (
//     <div className="fixed top-0 left-0 w-full z-40 px-4 py-3 bg-white shadow-md flex items-center justify-between">
//       {/* This is where the logo lands and stays visible after splash */}
//       <div ref={targetRef} className="w-14 h-14">
//         {!showSplash && (
//           <motion.img
//             src="https://ik.imagekit.io/1sb7q2nfg/AL%20BIDAYAH/LOGO/al%20bidaya.png"
//             alt="Logo"
//             className="w-full h-full object-contain"
//             initial={{ opacity: 0, scale: 0.8 }}
//             animate={{ opacity: 1, scale: 1 }}
//             transition={{ duration: 0.6, delay: 1.6 }}
//           />
//         )}
//       </div>

//       {/* Hamburger Menu */}
//       <button
//         className="flex flex-col gap-1 focus:outline-none"
//         onClick={toggleMenu}
//       >
//         <span className="w-6 h-0.5 bg-black" />
//         <span className="w-6 h-0.5 bg-black" />
//         <span className="w-6 h-0.5 bg-black" />
//       </button>
//     </div>
//   );
// };

// export default Navbar;



// import React from "react";
// import { motion } from "framer-motion";

// const Navbar = ({ showSplash, toggleMenu, targetRef }) => {
//   return (
//     <div className="fixed top-0 left-0 w-full z-40 px-4 py-3 bg-white shadow-md flex items-center justify-between">
//       <div ref={targetRef} className="w-14 h-14">
//         {!showSplash && (
//           <motion.img
//             src="https://ik.imagekit.io/1sb7q2nfg/AL%20BIDAYAH/LOGO/al%20bidaya.png"
//             alt="Logo"
//             className="w-full h-full object-contain"
//             initial={{ opacity: 0, scale: 0.8 }}
//             animate={{ opacity: 1, scale: 1 }}
//             transition={{ duration: 0.6, delay: 0.4 }}
//           />
//         )}
//       </div>

//       <button
//         className="flex flex-col gap-1 focus:outline-none"
//         onClick={toggleMenu}
//       >
//         <span className="w-6 h-0.5 bg-black" />
//         <span className="w-6 h-0.5 bg-black" />
//         <span className="w-6 h-0.5 bg-black" />
//       </button>
//     </div>
//   );
// };

// export default Navbar;



// import React from "react";
// import { motion } from "framer-motion";

// const Navbar = ({ showSplash, toggleMenu, targetRef }) => {
//     return (
//         <div className="fixed top-0 left-0 w-full z-40 px-4 py-3 bg-black shadow-md flex items-center justify-between">
//             <div ref={targetRef} className="w-20 h-20">
//                 <a href="/">
//                     {!showSplash && (
//                         <motion.img
//                             src="https://ik.imagekit.io/1sb7q2nfg/AL%20BIDAYAH/LOGO/al%20bidaya.png"
//                             alt="Logo"
//                             className="w-full h-full object-contain"
//                             initial={{ opacity: 0, scale: 1.8 }}
//                             animate={{ opacity: 1, scale: 1 }}
//                             transition={{ duration: 0.6, delay: 0.4 }}
//                         />
//                     )}
//                 </a>
//             </div>

//             <button
//                 className="flex flex-col gap-1 focus:outline-none"
//                 onClick={toggleMenu}
//             >
//                 <span className="w-6 h-0.5 bg-white" />
//                 <span className="w-6 h-0.5 bg-white" />
//                 <span className="w-6 h-0.5 bg-white" />
//             </button>
//         </div>
//     );
// };

// export default Navbar;


// import React, { useEffect, useState } from "react";
// import { motion, useAnimation } from "framer-motion";

// const Navbar = ({ showSplash, toggleMenu, targetRef }) => {
//   const [isTop, setIsTop] = useState(true);
//   const controls = useAnimation();

//   useEffect(() => {
//     const handleScroll = () => {
//       const atTop = window.scrollY <= 10;
//       setIsTop(atTop);

//       controls.start(atTop ? "atTop" : "scrolled");
//     };

//     handleScroll(); // Initial check
//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, [controls]);

//   const logoVariants = {
//     atTop: {
//       y: 20,
//       scale: 1.3,
//       transition: { duration: 0.4, ease: "easeOut" },
//     },
//     scrolled: {
//       y: 0,
//       scale: 1,
//       transition: { duration: 0.4, ease: "easeOut" },
//     },
//   };

//   return (
//     <div className="fixed top-0 left-0 w-full z-[1000] px-20 max-sm:px-5 py-3 bg-black shadow-md flex items-center justify-between">
//       <div ref={targetRef} className="w-20 h-20 overflow-visible">
//         <a href="/">
//           {!showSplash && (
//             <motion.img
//               src="https://albidayahgroups.com/Media/Logo/Al%20Bidayah%20Logo.png"
//               alt="Logo"
//               className="w-full h-full object-contain"
//               variants={logoVariants}
//               animate={controls}
//               initial="atTop"
//             />
//           )}
//         </a>
//       </div>

//       <button
//         className="flex flex-col gap-1 focus:outline-none"
//         onClick={toggleMenu}
//       >
//         <span className="w-6 h-0.5 bg-white" />
//         <span className="w-6 h-0.5 bg-white" />
//         <span className="w-6 h-0.5 bg-white" />
//       </button>
//     </div>
//   );
// };

// export default Navbar;



import React, { useEffect, useState } from "react";
import { motion, useAnimation } from "framer-motion";

const Navbar = ({ showSplash, toggleMenu, targetRef }) => {
  const [isTop, setIsTop] = useState(true);
  const controls = useAnimation();

  useEffect(() => {
    const handleScroll = () => {
      const atTop = window.scrollY <= 10;
      setIsTop(atTop);

      controls.start(atTop ? "atTop" : "scrolled");
    };

    handleScroll(); // Initial check
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [controls]);

  const logoVariants = {
    atTop: {
      y: 20,
      scale: 1.3,
      transition: { duration: 0.4, ease: "easeOut" },
    },
    scrolled: {
      y: 0,
      scale: 1,
      transition: { duration: 0.4, ease: "easeOut" },
    },
  };

  return (
    <div className="fixed top-0 left-0 w-full z-[1000] px-20 max-sm:px-5 py-3 bg-black shadow-md flex items-center justify-between">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-10"
        style={{ backgroundImage: `url('https://albidayahgroups.com/Media/Restaurant/pattern%20bg.svg')` }}
      ></div>
      <div ref={targetRef} className="w-20 h-20 overflow-visible">
        <a href="/">
          {!showSplash && (
            <motion.img
              src="https://albidayahgroups.com/Media/Logo/RAB_logo_New.png"
              alt="Logo"
              className="w-full h-full object-cover relative"
              variants={logoVariants}
              animate={controls}
              initial="atTop"
            />
          )}
        </a>
      </div>

      <button
        className="flex flex-col gap-1 focus:outline-none relative"
        onClick={toggleMenu}
      >
        <span className="w-6 h-0.5 bg-white" />
        <span className="w-6 h-0.5 bg-white" />
        <span className="w-6 h-0.5 bg-white" />
      </button>
    </div>
  );
};

export default Navbar;










// export default function Navbar({ show, logoRef }) {
//   return (
//     <nav
//       className={`fixed top-0 left-0 w-full h-16 bg-white shadow-md z-40 flex items-center px-6 transition-all duration-700 ${
//         show ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-6"
//       }`}
//     >
//       <img
//         ref={logoRef}
//         src="https://ik.imagekit.io/1sb7q2nfg/AL%20BIDAYAH/LOGO/al%20bidaya.png"
//         alt="Logo"
//         className="w-10 opacity-0 transition-opacity duration-500"
//       />
//       <h1 className="ml-3 text-xl font-semibold text-gray-800">AL-BIDAYAH</h1>
//     </nav>
//   );
// }
